import { plainToInstance, Type } from "class-transformer";

import { PostActionTypeEnum, PostType } from "../../../types";
import { PostActionModel } from "../PostActionModel";
import { PostMessage } from "../PostMessage";

export default class SendCommentActionModel extends PostActionModel {
    type = PostActionTypeEnum.SendCommentAction;

    @Type(() => PostMessage)
    message: PostMessage = plainToInstance(PostMessage, {
        type: PostType.Post,
        variants: [ {
            'text': '',
            'buttons': [],
            'disable_link_preview': false,
            'attachments': [],
            'send_after': 0,
            'remove_after': 0,
            'protect_content': false,
        } ]
    })
}
